// Array of routes that don't need authentication
export const unauthenticatedRoutes: string[] = ['/register', '/', '/forgotpassword', '/verify']
